import Button from '@ui-library/button';
import { apiAuthCaller } from '@services/apiCaller';
import { IUserStore } from '@stores/user';
import { AxiosResponse } from 'axios';
import { inject, observer } from 'mobx-react';
import React from 'react';
import retry from '@utils/retry';
import { FixMe } from '@utils/types';

interface StoreProps {
  userStore?: IUserStore;
}
interface RefreshProps<T> extends StoreProps {
  onComplete?: (config: FixMe) => void;
  field?: RequestParams & IFieldProps;
  setParentDisabled?: (val: boolean) => void;
  onIncomplete?: (err: FixMe) => void;
  ButtonComp?: FixMe;
  hide?: boolean;
  fetchDataOnClick?: () => Promise<T[]>;
}

interface IFieldProps {
  useToken?: boolean;
}
interface RequestParams {
  url: string;
  timeout?: number;
  params?: { [i: string]: FixMe };
  method?: 'get' | 'post';
}
interface RefreshState {
  refreshing: boolean;
}

class RefreshButton<T> extends React.Component<RefreshProps<T>, RefreshState> {
  constructor(props: RefreshProps<T>) {
    super(props);
    this.state = {
      refreshing: false,
    };
  }

  static getData = async (
    { method = 'get', url, params, timeout }: RequestParams,
    token: string,
    nonWorkspaceRoute = false,
  ) => {
    let response: AxiosResponse;
    if (method === 'get') {
      response = await apiAuthCaller(token, nonWorkspaceRoute, timeout).get(url, {
        params,
      });
    } else {
      response = await apiAuthCaller(token, nonWorkspaceRoute, timeout).post(url, params);
    }

    return response.data;
  };

  public refreshButtonCLick = async () => {
    const { field, onComplete, setParentDisabled, onIncomplete, fetchDataOnClick, userStore } =
      this.props;
    this.setState({ refreshing: true });
    if (setParentDisabled) {
      setParentDisabled(true);
    }
    try {
      let data;
      if (fetchDataOnClick) {
        data = await fetchDataOnClick();
      } else if (field) {
        const { url, params, method, timeout, useToken } = field;
        data = await retry(() =>
          RefreshButton.getData({ url, params, method, timeout }, userStore?.token || '', useToken),
        );
      }
      if (onComplete) {
        onComplete(data);
      }
    } catch (err) {
      if (onIncomplete) {
        onIncomplete(err);
      }
    } finally {
      this.setState({ refreshing: false });
      if (setParentDisabled) {
        setParentDisabled(false);
      }
    }
  };

  public currState = () => {
    const { ButtonComp } = this.props;
    const { refreshing } = this.state;
    const RefreshButtonComp = ButtonComp || <Button textPrimary />;

    return <RefreshButtonComp refreshing={refreshing} onClick={this.refreshButtonCLick} />;
  };

  render() {
    return !this.props.hide ? this.currState() : null;
  }
}
export default inject('userStore')(observer(RefreshButton));
